import {
  GroupUI,
  ChatMemberModel,
  ChatModel,
  EventViewUI,
  PollUI,
  UserUI,
  CommitteeUI,
  OrganisationUI,
} from '@src/models';

export type ListTypes = 'channels' | 'chats' | 'committees' | 'events' | 'organisations' | 'polls' | 'users';
export type ItemType =
  | GroupUI
  | ChatMemberModel
  | ChatModel
  | CommitteeUI
  | EventViewUI
  | OrganisationUI
  | PollUI
  | UserUI
  | null;
export type ActionIconTypes = '@tui.x' | '@tui.message-square';
export type ActionTypes = 'delete' | 'subscribe' | 'unsubscribe' | 'send' | 'link';

export interface ItemAction {
  type: ActionTypes;
  icon?: ActionIconTypes;
  title?: string;
  isVisible?: (item: ItemType) => boolean; // TODO: заменить на тип Observable<boolean>
  clickCallback: (item?: ItemType) => void;
}
